<template>
  <div class="sku-select-popup-mobile">
    <div class="sku-select-popup-mobile__header">
      <slot name="img" />
      <slot name="title" />
    </div>

    <slot name="sku-selectors" />

    <div class="sku-select-popup-mobile__footer">
      <slot name="price-block" />
      <slot name="button" />
    </div>
  </div>
</template>

<style scoped lang="stylus">
.sku-select-popup-mobile
  display flex
  flex-direction column
  gap 24px
  position relative

  &__header
    display grid
    gap 16px
    grid-template-columns 84px 1fr

  &__footer
    display flex
    justify-content space-between
    gap 12px
    background-color #ffffff
    position sticky
    bottom 0
    padding 8px 0 16px
</style>
